import FindingPinInBox from './FindingPinInBox';

export default FindingPinInBox;
